import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const powai: AreaConfig = {
  name: 'Powai',
  slug: 'powai',
  tagline: 'Doorstep iPhone & Mobile Repair in Powai — Premium Service',
  description: 'Tech professionals in Powai deserve tech-forward repair service. minto sends certified technicians to Hiranandani Gardens, IIT campus area, and all Powai localities. Get your iPhone or premium phone repaired at home with OEM parts and 6-month warranty.',
  localities: [
    'Hiranandani Gardens', 'Powai Lake', 'IIT Bombay Campus', 'Chandivali',
    'Nahar Complex', 'Central Avenue', 'Galleria', 'Powai Plaza',
    'Vikhroli West', 'Kanjurmarg West', 'L&T Gate',
  ],
  zones: [
    {
      name: 'Hiranandani Gardens & Lake Area',
      line: 'Metro / Road',
      station: 'Kanjurmarg Metro / Powai Lake',
      localities: ['Hiranandani Gardens', 'Powai Lake', 'Central Avenue', 'Galleria', 'Haiko Mall area', 'Powai Plaza'],
      desc: 'The heart of Powai — Hiranandani residents and professionals working in nearby IT parks. Technician arrives within 30 minutes.',
    },
    {
      name: 'IIT Area & Chandivali',
      line: 'Central Line access',
      station: 'Kanjurmarg / Vikhroli Station',
      localities: ['IIT Bombay Campus', 'Chandivali', 'Nahar Complex', 'Vikhroli West', 'L&T Gate', 'Kanjurmarg West'],
      desc: 'Covering the IIT campus surroundings and Chandivali residential complexes. Popular with tech-savvy professionals who prefer premium repair quality.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Powai | Doorstep iPhone Repair Hiranandani | minto',
    description: 'Expert doorstep mobile & iPhone repair in Powai, Hiranandani Gardens, Chandivali. OEM battery replacement, screen repair with 6-month warranty. No Unknown Part warning. 30-min service.',
    keywords: 'mobile repair Powai, iPhone repair Powai, phone repair Hiranandani, battery replacement Powai, screen repair Powai, doorstep mobile repair Powai, iPhone service Hiranandani Gardens, mobile repair Chandivali, phone repair IIT Bombay area',
  },
  faqs: [
    {
      q: 'Do you provide doorstep repair in Hiranandani Gardens Powai?',
      a: 'Yes! We cover all towers and streets in Hiranandani Gardens. Our technician comes to your apartment and repairs the phone right in front of you within 30-60 minutes.',
    },
    {
      q: 'How much does iPhone battery replacement cost in Powai?',
      a: 'iPhone battery replacement starts from ₹2,499 depending on the model. All replacements include OEM-quality parts with 6 months warranty and zero Unknown Part warning.',
    },
    {
      q: 'Can you repair phones at my office in Powai?',
      a: 'Absolutely. Many of our Powai customers are working professionals. We come to your office lobby or meeting room, repair the phone, and you\'re back to work.',
    },
    {
      q: 'Do you cover Chandivali and Vikhroli near Powai?',
      a: 'Yes, our service covers Chandivali, Nahar Complex, Vikhroli West, and Kanjurmarg — all adjacent areas to Powai with similar fast arrival times.',
    },
  ],
};

const PowaiPage: React.FC = () => <AreaLandingPage area={powai} />;
export default PowaiPage;
